module.exports = __webpack_public_path__ + "img/guide_5_2.23ccbf6a.svg";